// REACT
import React, { Component } from 'react';

// REDUX
import { connect } from 'react-redux';
import * as actions from '../actions';

import { Redirect } from 'react-router-dom';

// VENDOR COMPONENTS
import MenuItem from 'material-ui/MenuItem';

import { withRouter } from 'react-router-dom';

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            scrollToTop: false,
            showSchedule: false,
            showSearchFilter: false,
        };
    }

    componentDidMount() {
        if (!this.props.userId) this.props.openLoginDialog();
        // console.log('USERID', this.props.userId, this.props.userData)
    }

    componentWillUnmount() {
        this.props.closeLoginDialog();
    }

    render() {
        const { userData, userId } = this.props;
        const isSuperUser =
            userData && userData.roles && userData.roles.superUser;
        const isProvider = userData && userData.provider;
        const isAuthenticated = !!userId;
        return (
            <div
                className="mainImageDiv"
                style={{
                    // TODO: REPLACE RANDOM FILLER IMAGE
                    background: `url('https://firebasestorage.googleapis.com/v0/b/cyno-telephysio-pilot.appspot.com/o/stockImages%2FiStock-542827872_med.jpeg?alt=media&token=59ed74c2-d2a7-4311-8f8c-0a3c6519507b') 45% 95% no-repeat`,
                    WebkitFilter: 'blur(2px)',
                    backgroundSize: 'cover',
                    minHeight: '100vh',
                    width: '100vw',
                }}
            >
                {isAuthenticated && (
                    <React.Fragment>
                        {isProvider && <Redirect to="/modules" />}
                        {!isProvider && !isSuperUser && (
                            <Redirect to="/my-services" />
                        )}
                    </React.Fragment>
                )}
            </div>
        );
    }
}

const mapStateToProps = ({ auth, router, client }) => ({
    userId: auth.authData && auth.authData.uid,
    location: router.location,
    userData: client.clientData,
});

export default withRouter(
    connect(
        mapStateToProps,
        actions,
    )(App),
);



// WEBPACK FOOTER //
// ./src/js/containers/App.jsx